export type NameProfile =
  | { displayName?: string | null; fullName?: string | null }
  | null
  | undefined;

// Prefer the user's chosen display name over their full legal name, e.g. so a
// guest can avoid sharing their last name with a host before a booking is accepted.
export function nameFor(profile: NameProfile, fallback = "User"): string {
  return profile?.displayName || profile?.fullName || fallback;
}
